import { MenuItem, styled } from '@ethings/ui-toolkit';
import { FC } from 'react';
import { testid } from '../../util';
import { SelectionCheckBox } from './selection-check-box';

interface Props {
  groupDisplay: string;
  itemsChecked: string[];
  subItemDisplay: (subItem: string) => string;
  subItems: string[];
  updateSelectedValue: (value: string[]) => void;
  wrap?: boolean;
}

const StyledMenuItem = styled(MenuItem)({
  padding: 0,
});

export const SelectionCheckBoxGroup: FC<Props> = ({
  groupDisplay,
  itemsChecked,
  subItemDisplay,
  subItems,
  updateSelectedValue,
  wrap,
}) => {
  const isAllChecked = itemsChecked.length === subItems.length;

  const handleAllChange = (): void => {
    if (isAllChecked) return updateSelectedValue([]);
    updateSelectedValue(subItems);
  };

  const handleIndividualChange = (itemName: string) => (): void => {
    if (itemsChecked.includes(itemName)) {
      updateSelectedValue(itemsChecked.filter((itemChecked) => itemChecked !== itemName));
      return;
    }
    updateSelectedValue([...itemsChecked, itemName]);
  };

  return <>
    <StyledMenuItem>
      <SelectionCheckBox
        checked={isAllChecked}
        data-testid={testid`selection-checkbox-${groupDisplay}`}
        handleClick={handleAllChange}
        indeterminate={itemsChecked.length > 0 && itemsChecked.length < subItems.length}
        label={groupDisplay}
        wrap={wrap}
      />
    </StyledMenuItem>
    {subItems.map((subItem, j) =>
      <StyledMenuItem key={j}>
        <SelectionCheckBox
          key={j}
          checked={itemsChecked.includes(subItem)}
          data-testid={testid`selection-checkbox-subitem-${subItem}`}
          handleClick={handleIndividualChange(subItem)}
          label={subItemDisplay(subItem)}
          subItem
          wrap={wrap}
        />
      </StyledMenuItem>,
    )}
  </>;
};
